import { Users, FileBox, Building, AlertCircle } from "lucide-react";
const escenarios = [{
  icon: Users,
  title: "El broker que cree estar cubierto",
  desc: "\"La notaría ya hizo el KYC del comprador, yo no tengo que hacer nada.\" Error. Con la reforma, cada sujeto obligado que participa en la operación — vendedor, notaría, broker — debe tener su propio expediente. Guardar una copia del KYC de otro no es cumplir."
}, {
  icon: FileBox,
  title: "La joyería o agencia de vehículos que lo hace en papel",
  desc: "Expedientes en carpetas, verificaciones a mano, reportes que toman horas. Una compraventa de $150,000 MXN ya entra en actividad vulnerable, pero un dato mal capturado o un screening sin hacer puede convertirse en responsabilidad penal por negligencia."
}, {
  icon: Building,
  title: "La desarrolladora que vende sobre planos",
  desc: "Con la reforma 2025, el desarrollo inmobiliario es actividad vulnerable independiente (Art. 17 Fr. V Bis — nueva). Ya no basta con el KYC de la notaría al momento de escriturar: cada pago recibido durante la construcción requiere identificación propia del comprador."
}, {
  icon: AlertCircle,
  title: "El negocio que no sabe que es sujeto obligado",
  desc: "La LFPIORPI aplica a 17 actividades vulnerables: notarías, joyerías, inmobiliarias, brokers, blindadoras, compraventa de vehículos, juegos y sorteos, activos virtuales, comercio exterior, mediadores, donativos, y más. Muchos negocios operan sin saber que la ley les aplica — hasta que llega la primera verificación."
}];
export default function ElProblema() {
  return <section data-section-id="REEMPLAZAR" id="el-problema" className="bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 flex flex-col items-center text-center">
          <h2 className="font-default text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl max-w-3xl">
            Si alguno de estos escenarios te suena familiar,{" "}
            <span className="text-primary font-mono">no estás solo</span>
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {escenarios.map((escenario, i) => {
          const Icon = escenario.icon;
          return <div key={escenario.title} data-index={i} className="p-6 md:p-8 rounded-lg bg-card border border-border hover:border-primary/30 transition-colors">
                <div className="flex items-center gap-3 mb-4">
                  <div className="size-10 rounded-md bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Icon className="size-5 text-primary" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-default text-lg md:text-xl font-bold text-white">
                    {escenario.title}
                  </h3>
                </div>
                <p className="font-default text-sm md:text-base text-slate-400 leading-relaxed">
                  {escenario.desc}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}